import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const FinalCTA = () => {
  const { t } = useTranslation('home');

  return (
    <section className="bg-primary py-24 md:py-32 relative overflow-hidden">
      {/* Radial glow effect */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent scale-150" />

      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <motion.h2
          className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-heading font-black text-white uppercase tracking-tight mb-12 leading-none"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          {t('finalCta.headline')} <br />{t('finalCta.headlinePart2')}
        </motion.h2>

        <motion.div
          className="flex flex-col sm:flex-row items-center justify-center gap-6"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <Link
            to="/book-inspection"
            onClick={() => {
              if (typeof window !== 'undefined' && (window as any).fbq) {
                (window as any).fbq('track', 'Contact', {
                  content_name: 'Get Free Inspection Button - CTA'
                });
              }
            }}
            className="w-full sm:w-auto bg-white text-primary text-lg md:text-xl font-bold px-10 md:px-12 py-5 md:py-6 rounded-full hover:bg-gray-50 transition-all shadow-2xl shadow-red-900/40 transform hover:-translate-y-1"
          >
            {t('finalCta.button')}
          </Link>

          <a
            href="tel:+13462200989"
            className="w-full sm:w-auto bg-transparent border-2 border-white/30 text-white text-lg md:text-xl font-bold px-10 md:px-12 py-5 md:py-6 rounded-full hover:bg-white hover:text-primary hover:border-white transition-all"
          >
            {t('finalCta.callButton')}
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;
